module.exports = __webpack_public_path__ + "static/media/shaun.8adc1ec4.jpg";